import {getTestProps} from '@benchling/js-test-utils';
import React from 'react';

import Tooltip from 'ui-library/bs/Tooltip';
import RegressionConfigModal, {
  hasParameterCustomizations,
  RegressionConfigModalSupportedConfig,
} from 'ui-library/charting/statistics/regression/regression-config-modal/RegressionConfigModal';
import {RegressionConfig} from 'ui-library/charting/statistics/regression/RegressionTypes';
import SettingsIcon from 'ui-library/icons/SettingsIcon';
import legacyRunModal from 'ui-library/legacyRunModal';

export const DEFAULT_TOOLTIP = 'Customize regression';
export const CUSTOMIZED_TOOLTIP = 'Custom regression applied';

interface RegressionSettingsIconProps {
  regressionConfig: RegressionConfig;
  onRequestSubmit: (newRegressionConfig: RegressionConfig) => void;
  isDisabled?: boolean;
}

export default function RegressionSettingsIcon({
  regressionConfig,
  onRequestSubmit,
  isDisabled = false,
}: RegressionSettingsIconProps): JSX.Element {
  const isCustomized = hasParameterCustomizations(regressionConfig);
  const tooltipText = isCustomized ? CUSTOMIZED_TOOLTIP : DEFAULT_TOOLTIP;
  return (
    <Tooltip title={tooltipText}>
      <span {...getTestProps({component: 'RegressionSettingsIcon', element: 'root'})}>
        <SettingsIcon
          className="u-small-spacing-left"
          highlighted={isCustomized}
          onClick={() => {
            legacyRunModal(RegressionConfigModal, {
              regressionConfig: regressionConfig as RegressionConfigModalSupportedConfig,
              onRequestSubmit,
            });
          }}
          disabled={isDisabled}
        />
      </span>
    </Tooltip>
  );
}
